import Header from "./header"

import "./upsell.scss"

interface Props {
  onSkip: () => void
  onTryProClick: () => void
  onClickBack: () => void
  trialConfig: {
    assets: {
      proIllustration: string
      proPlusIllustration: string
    }
    urls: {
      proSubscriptionsUrl: string
      proPlusSubscriptionsUrl: string
    }
  }
}

const Upsell = ({ onSkip, onTryProClick, trialConfig, onClickBack }: Props) => {
  const title = window.App.AIServicesReady ? "Try our new tools" : "Start your trial"
  const body = window.App.AIServicesReady
    ? "Our AI Content Creator, AI Meeting Assistant, and AI Social Media Specialist are here to help you save time and increase productivity."
    : "Subscribe to get full access to popular Applets and features. Make your favorite things work better together."
  const url = window.App.AIServicesReady
    ? trialConfig.urls.proPlusSubscriptionsUrl
    : trialConfig.urls.proSubscriptionsUrl
  const image = window.App.AIServicesReady ? trialConfig.assets.proPlusIllustration : trialConfig.assets.proIllustration

  return (
    <>
      <Header title="" onClickBack={onClickBack} />
      <div styleName="container">
        <section styleName="welcome">
          <img src={image} alt="Try Pro for Free" />
          <h1>{title}</h1>
          <p>{body}</p>
        </section>

        <div className="flexbox">
          <section styleName="action-buttons-container" className="action-buttons-container">
            <a
              href={url}
              role="button"
              data-turbolinks="false"
              className="button-primary pay-later"
              onClick={onTryProClick}
            >
              Continue
            </a>

            <a onClick={onSkip} styleName="skip-pro-link">
              Not now
            </a>
          </section>
        </div>
      </div>
    </>
  )
}

export default Upsell
